import {Flex, Skeleton, Text, useTheme} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import React, {useEffect, useMemo} from 'react'
import {FormattedMessage} from 'react-intl'
import AddToCartCTA from '../../../components/add-to-cart-cta'
import {getProductsToAddToCart} from '../../../utils/product-utils'
import ProductDisplayPrice from '../../../components/product-display-price'
import useBreakpoints from '../../../hooks/use-breakpoints'
import {useZendeskChat} from '../../../components/zendesk-chat'
import {useCommerceData} from '../../../hooks/use-commerce-data'

const PsdpCta = ({derivedProduct, product, isLoading, onAddToCartClick}) => {
    const theme = useTheme()
    const {isEcommerceEnabled, showPricesOnContentOnly} = useCommerceData(product)

    const totalProducts = useMemo(() => getProductsToAddToCart(product).length, [product])

    // move Zendesk on mobile view to not overlap with the CTA
    const offset = useBreakpoints(
        // matches the display and height with some margin of the cta
        {base: '5rem', lg: 0}
    )
    const zendeskApi = useZendeskChat()

    useEffect(() => {
        zendeskApi?.setBottomOffset(offset)
    }, [zendeskApi, offset])

    return (
        <Flex
            display={{base: 'flex', lg: 'none'}}
            position="fixed"
            left={0}
            bottom={0}
            width="100%"
            zIndex="sticky"
            align="center"
            height={18}
            gap={4}
            background="stokkeCore.white"
            boxShadow={theme.shadows.top}
        >
            {(isEcommerceEnabled || showPricesOnContentOnly) && (
                <Flex
                    paddingLeft={4}
                    paddingRight={3}
                    minW="0"
                    flex="1"
                    justifyContent="end"
                    alignItems="start"
                    flexDirection="column"
                    gap={1}
                >
                    <Flex gap={1.5}>
                        <Text textStyle="Regular Extra Small">
                            <FormattedMessage id="global.total" defaultMessage="Total" />
                        </Text>
                        <Skeleton isLoaded={!isLoading}>
                            <Text
                                textStyle="Regular Extra Small"
                                whiteSpace="nowrap"
                                color="stokkeGray.accessibleText"
                            >
                                <FormattedMessage
                                    id="product_set_detail.cockpit.product-count"
                                    defaultMessage="{totalProducts} products"
                                    values={{totalProducts: totalProducts}}
                                />
                            </Text>
                        </Skeleton>
                    </Flex>
                    <ProductDisplayPrice
                        product={product}
                        loading={isLoading}
                        variant="stickyCta"
                    />
                </Flex>
            )}
            <Flex
                paddingLeft={{base: 2, md: 0}}
                paddingRight={2}
                minW="0"
                flex="1"
                justifyContent="right"
                alignItems="center"
                gap={2.5}
            >
                <AddToCartCTA
                    isLoading={isLoading}
                    product={product}
                    quantity={derivedProduct?.quantity}
                    onClick={onAddToCartClick}
                    variant="solidGreen"
                />
            </Flex>
        </Flex>
    )
}

PsdpCta.propTypes = {
    derivedProduct: PropTypes.object,
    product: PropTypes.object,
    isLoading: PropTypes.bool,
    onAddToCartClick: PropTypes.func
}

export default PsdpCta
